export default {
  setOrders(state, payload) {
    state.orders = payload;
  },
  setOrderCount(state, payload) {
    state.orderCount = payload;
  },
  setCustomerCount(state, payload) {
    state.customerCount = payload;
  },
  setSubscriberCount(state, payload) {
    state.subscriberCount = payload;
  },
  setStoreBalance(state, payload) {
    state.storeBalance = payload;
  },
  resetReports(state, payload) {
    state.reportsMessages = { nextPageToken: "", data: [] };
    state.reportsClicks = { nextPageToken: "", data: [] };
    state.reportsConversion = { nextPageToken: "", data: [] };
    state.reportsStream = { nextPageToken: "", data: [] };
    state.campaignsMessages = { nextPageToken: "", data: [] };
    state.campaignsClicks = { nextPageToken: "", data: [] };
    state.campaignsConversion = { nextPageToken: "", data: [] };
  },
  setReportMessages(state, payload) {
    state.reportsMessages = {
      data: state.reportsMessages.data.concat(payload.messages),
      nextPageToken: payload.nextPageToken
    };
  },
  setReportConversions(state, payload) {
    state.reportsConversion = {
      data: state.reportsConversion.data.concat(payload.conversions),
      nextPageToken: payload.nextPageToken
    };
  },
  setReportClicks(state, payload) {
    state.reportsClicks = {
      data: state.reportsClicks.data.concat(payload.links),
      nextPageToken: payload.nextPageToken
    };
  },
  setReportStream(state, payload) {
    state.reportsStream = {
      data: state.reportsStream.data.concat(payload.stream),
      nextPageToken: payload.nextPageToken
    };
  },
  setCampaignsMessages(state, payload) {
    state.campaignsMessages = {
      data: state.campaignsMessages.data.concat(payload.recipients),
      nextPageToken: payload.nextPageToken
    };
  },
  setCampaignsConversions(state, payload) {
    state.campaignsConversion = {
      data: state.campaignsConversions.data.concat(payload.conversions),
      nextPageToken: payload.nextPageToken
    };
  },
  setCampaignsClicks(state, payload) {
    state.campaignsClicks = {
      data: state.campaignsClicks.data.concat(payload.links),
      nextPageToken: payload.nextPageToken
    };
  },
  setStoreReport(state, payload) {
    state.storeReport = payload;
  },
  setExistingDiscounts(state, payload) {
    state.existingDiscounts = payload;
  },
  setShippingCountries(state, payload) {
    state.shippingCountries = payload;
  }
};
